import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Form, FormGroup } from "react-bootstrap";

import Button from "../../../../components/common/button/Button";
import Input from "../../../../components/common/input/Input";
import Select2 from "../../../../components/common/select/Select2";
import Textarea from "../../../../components/common/textarea/Textarea";
import {
  required,
  dropdown,
  alphaSymbolicSpace,
  email
} from "../../../../utils/forms/validators";

import * as userActions from "../../../../actions/user.actions";
import { COMPANY_PAYMENT_FORM } from "../../../../actions/company.actions";
import styles from "./CompanyPaymentInformation.scss";

const dropdownValidation = msg => dropdown(msg);

const firstName = alphaSymbolicSpace("Please enter a valid first name.");
const lastName = alphaSymbolicSpace("Please enter a valid last name.");
const emailVal = email("Please enter a valid email address.");
const paymentMethod = dropdownValidation("Please select a Payment Method.");
// const paymentTerm = dropdownValidation("Please select a Payment Term.");

class CompanyPaymentInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      method: null
    };

    this.handlePaymentMethodChange = this.handlePaymentMethodChange.bind(this);
  }

  componentDidMount() {
    this.props.userActions.getUserData();
  }

  handlePaymentMethodChange(value) {
    this.setState({ method: value });
  }

  renderPaymentMethodField() {
    const PAYMENT_TERM_OTHER = _.first(
      _.filter(this.props.paymentTerms, { value: "Other" })
    );

    // Other
    if (!this.state.method || this.state.method !== PAYMENT_TERM_OTHER.id)
      return null;

    return (
      <Field
        name="payment_term_other"
        type="text"
        placeholder="Value"
        component={Input}
        onChange={this.handleMethodChange}
        validate={[required]}
      />
    );
  }

  render() {
    const {
      handleSubmit,
      submitting,
      valid,
      paymentMethods
      // paymentTerms
    } = this.props;

    return (
      <section className={styles.section}>
        <div className={styles.content}>
          <h2 className={styles.title}>Edit Payment Information</h2>

          <Form onSubmit={handleSubmit}>
            <div className={styles.form}>
              <FormGroup>
                <Field
                  name="first_name"
                  type="text"
                  placeholder="Billing Contact First Name"
                  component={Input}
                  validate={[required, firstName]}
                  autoFocus={true}
                />

                <Field
                  name="last_name"
                  type="text"
                  placeholder="Billing Contact Last Name"
                  component={Input}
                  validate={[required, lastName]}
                />

                <Field
                  name="email"
                  type="text"
                  placeholder="Billing Contact Email Address"
                  component={Input}
                  validate={[required, emailVal]}
                />

                <Field
                  name="payment_method_id"
                  type="select"
                  placeholder="Preferred Billing Method"
                  component={Select2}
                  options={paymentMethods}
                  validate={paymentMethod}
                />

                {/* <Field
                  name="payment_term_id"
                  type="select"
                  placeholder="Payment Terms"
                  component={Select2}
                  options={paymentTerms}
                  validate={paymentTerm}
                  onSelectChange={this.handlePaymentMethodChange}
                /> */}

                {this.renderPaymentMethodField()}

                <Field
                  name="billing_notes"
                  type="textarea"
                  component={Textarea}
                  label="Billing Notes"
                  maxlength={2500}
                />

                <Button
                  isPrimary
                  type="submit"
                  size={"large"}
                  label="Save Changes"
                  isDisabled={!valid || submitting}
                />
              </FormGroup>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

CompanyPaymentInformation = reduxForm({
  form: COMPANY_PAYMENT_FORM,
  enableReinitialize: true,
  touchOnBlur: true,
  touchOnChange: true
})(CompanyPaymentInformation);

CompanyPaymentInformation = connect(
  state => {
    const user = state.user.data;
    const company = _.get(user, "profile.company");
    return {
      initialValues: {
        ..._.get(company, "payment"),
        company_id: _.get(company, "id")
      }
    };
  },
  dispatch => ({
    userActions: bindActionCreators(userActions, dispatch)
  })
)(CompanyPaymentInformation);

export default CompanyPaymentInformation;



// WEBPACK FOOTER //
// ./src/routes/employer/payment/components/CompanyPaymentInformation.js